import script from "./CreateKeyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateKeyForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateKeyForm.vue?vue&type=style&index=0&id=ed5f9326&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed5f9326"]])

export default __exports__